var kind = require("enyo/kind");

require("enyo-ui");

/**
 * [SliderArraySupport]{@link enyo-ui.SliderArraySupport} is designed to let
 * [Slider]{@link enyo-ui.Slider} use an Array as data source.
 *
 * This is a simple implementation that prunes existing slides when data changes
 * and buffers an initial set of slides.
 *
 * @mixin enyo-ui.SliderArraySupport
 * @public
 */
module.exports = {

    /**
     * @private
     */
    name: "enyo-ui.SliderArraySupport",

    /**
     * @memberof enyo-ui.SliderArraySupport
     * @method
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            sup.apply(this, arguments);
            this.dataChanged();
        };
    }),

    /**
     * Super naive implementation, simply clears the slider, updates length and
     * snaps to the requested index in the new dataset, falling back to the
     * first index if no requested index was supplied.
     *
     * @param {Array}  previous  The previous array
     * @memberof enyo-ui.SliderArraySupport
     * @private
     */
    dataChanged: function() {
        var data  = this.data || [],
            index = this.requestedIndex || 0;

        // First change properties derived from data
        this.set("length", data.length);

        // Then change UI
        this.clearSlides();
        this.length && this.snapToIndex(index);
    },

    /**
     * Gets a record from the dataset by index.
     *
     * @param    {number}  index  The index
     * @return   {*}       The record, or `null` if not found.
     * @memberof enyo-ui.SliderArraySupport
     * @private
     */
    getRecordByIndex: function(index) {
        return this.data[index] || null;
    },

    /**
     * Gets a record from the dataset by index.
     *
     * @param    {*}       record  The record
     * @return   {number}  The index, or `null` if not found.
     * @memberof enyo-ui.SliderArraySupport
     * @private
     */
    getIndexByRecord: function(record) {
        var index = this.data.indexOf(record);

        return index > -1 ? index : null;
    },

    /**
     * Gets a unique identifier for the record.
     *
     * @param    {*}       record  The record
     * @return   {string}  The record uid.
     * @memberof enyo-ui.SliderArraySupport
     * @private
     */
    getRecordUid: function(record) {
        return record.id;
    }

};
